import { useEffect } from "react";

const SelectTypeLines = ({ LocationTypeLines, selectedlocationTypeLine, setSelectedLocationTypeLine, disabled = false }) => {
    useEffect(() => {
        if (LocationTypeLines.length > 0) {
            setSelectedLocationTypeLine(LocationTypeLines[0].name);
        }
    }, [LocationTypeLines])    
    return (
        <select
        disabled={disabled}
        id='place-select'
        className='choice-select'
        value={selectedlocationTypeLine}
        onChange={(e) => setSelectedLocationTypeLine(e.target.value)}
        >
            {selectedlocationTypeLine === '' ? <option value="">
                ------
            </option> : null}
            {LocationTypeLines && LocationTypeLines.map((typeline) => (
                <option
                    key={typeline.id}
                    value={typeline.name}
                >
                    {typeline.name.toUpperCase()}
                </option>
            ))}
        </select>
    );
};

export default SelectTypeLines;